import { request } from '../../../shared/api/httpClient';
export interface CustomerNote { id: string; text: string; created_at: number; author: string }
export interface Customer {
  id: string; name: string; phone: string; description: string | null; total_price: number; created_at: number;
  store_id?: string; visits?: number; last_visit_at?: number; vip_tier?: number;
  customer_code?: string; email?: string; status?: 'active' | 'inactive';
  preferred_employee_id?: string; favorite_service?: string; allergy_note?: string; tags?: string[]; notes?: CustomerNote[];
}
export const customersApi = { get: async (id: string, signal?: AbortSignal) => (await request<{ customer: Customer }>('/customers/' + encodeURIComponent(id), { signal })).customer, list: async (signal?: AbortSignal) => (await request<{ customers: Customer[] }>('/customers', { signal })).customers };
